module.exports = __webpack_public_path__ + "static/media/Croatia_Morocco.07252cb9.jpeg";